import script from "./auto.vue?vue&type=script&setup=true&lang=js"
export * from "./auto.vue?vue&type=script&setup=true&lang=js"

import "./auto.css?vue&type=style&index=0&id=336a3293&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-sh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336a3293"]])

export default __exports__